import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/logos')
};

const postForm =  (payload,id) => {  

    if(typeof id != "undefined") {        

        return Api.post('api/logos/' + id , payload)
        
    } else {
        return Api.post('api/logos' , payload)       
    }
    
};

const getById = (payload) => {        
    return Api.get('api/logos/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/logos/'+payload)
    
};


export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};